export default "__VITE_ASSET__d5mx4DR5__"